import "./includes/scss/style.scss";

/* start aos */
AOS.init({ disable: 'mobile' });
/* end start */

/* Abilito elemento sticky top */
stickybits(".sticky-top", {
    useStickyClasses: true
});
stickybits(".sticky-top-menu", {
    useStickyClasses: true
});
stickybits(".sticky-bottom", {
    useStickyClasses: true,
    verticalPosition: 'bottom'
});
/****/

/* Jarallax */
if ($('.jarallax').length) {
    $('.jarallax').jarallax({
        speed: 0.6,
        //disableParallax: /iPad|iPhone|iPod|Android/,
        disableVideo: /iPad|iPhone|iPod|Android/
    });
};
/* end jarallax */

/* Marquee sldier brand */
if ($(".marquee").length) {
    $('.marquee').marquee({
        //duration in milliseconds of the marquee
        duration: 20000,
        //gap in pixels between the tickers
        gap: 0,

        pauseOnHover: true,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: true,
        //duplicate the message three times
        duplicateCount: 3,
        delayBeforeStart: 0,
        startVisible: true
    });
}
/***/

/* Header */
$(document).ready(function () {
    function checkScroll() {
        if ($(window).scrollTop() > 0) {
            $('header').addClass('scrolled');
            $('.banner-header').slideUp();
        } else {
            $('header').removeClass('scrolled');
            $('.banner-header').slideDown();
        }
    }

    // Controllo iniziale al caricamento
    checkScroll();

    // Controllo durante lo scroll
    $(window).on('scroll', function () {
        checkScroll();
    });
});
/*****/

/* Menu */

// Funzione per aggiornare la classe al body in base alla presenza della classe 'show'
function updateSubmenuState() {
    var active = $('.dropdown-toggle.show').length;
    if (active > 0) {
        $('body').addClass('submenu-open');
    } else {
        $('body').removeClass('submenu-open');
    }
}

// Applica un MutationObserver a tutti gli elementi .dropdown-toggle
$('.dropdown-toggle').each(function () {
    var targetNode = this;

    var observer = new MutationObserver(function (mutationsList) {
        for (var mutation of mutationsList) {
            if (mutation.attributeName === 'class') {
                updateSubmenuState();
            }
        }
    });

    observer.observe(targetNode, { attributes: true });
});

// Esegui subito la funzione per settare lo stato iniziale, se necessario
updateSubmenuState();
/****/

/* Menu mobile - aggiungo span all'interno del tag a */
$('#dexanet-menu-mobile a').wrapInner("<span></span>");
$(function () {
    $('#dexanet-menu-mobile a').each(function () {
        var $link = $(this);
        var href = $link.attr('href');

        if (!href || href === '#') {
            var spanContent = $link.find('span').clone(); // copia lo span
            $link.replaceWith(spanContent); // sostituisce l'intero <a> con il <span>
        }
    });
});
/****/

/* Menu mobile MMenu */
document.addEventListener(
    "DOMContentLoaded", () => {
        const menu = new MmenuLight(
            document.querySelector("#dexanet-menu-mobile")
        );

        const navigator = menu.navigation();
        const drawer = menu.offcanvas({
            position: "right"
        });

        document.querySelector('a[href="#dexanet-menu-mobile"]').addEventListener('click', (evnt) => {
            evnt.preventDefault();
            drawer.open();
        });

        document.querySelector('button.btn-close-mobile-menu').addEventListener('click', (evnt) => {
            drawer.close();
        });
    }
);
/******/

/** Contatti **/
$('.wpcf7-form .form-group .wpcf7-form-control').click(function () {
    $(this).closest('.form-group').addClass('input-active');
    $(this).next('.wpcf7-not-valid-tip').fadeOut();
});

$('.wpcf7-form .form-group .wpcf7-form-control ').focus(function () {
    $(this).closest('.form-group').addClass('input-active');
    $(this).next('.wpcf7-not-valid-tip').fadeOut();
});

$('.wpcf7-form .btn-send, .wpcf7-form .btn-invia').click(function () {
    $('.select2-selection').removeClass('select-error');
    setTimeout(function () {
        if ($('select').hasClass("wpcf7-not-valid")) {
            $('.select2-selection').addClass('select-error');
        }
    }, 700);
    $(this).removeClass('btn-error');
    if ($('.checkator_source').is(':checked')) {
        $('.custom-check').removeClass('error');
    } else {
        $('.custom-check').addClass('error');
    }
});

$(document).ready(function () {
    $("input[type=file]").on("change", function () {
        var fileName = $(this).val().replace(/.*[\/\\]/, '');
        $(this).closest('.custom-file').find('.custom-file-label').html(fileName);
    })
});

/* Empty contacts field on load of step one */
$(document).ready(function () {
    $('.wpcf7-form').find('input[name="email"]').val('');
    $('.wpcf7-form').find('textarea').val('');
});
/****/


$('.info-field-icon').on("click", function () {
    $('#hidden-info-field').toggleClass('active');
});
/**********************/

/* Input field */
var inputs = document.querySelectorAll('.wpcf7-file');
Array.prototype.forEach.call(inputs, function (input) {
    var label = $('.input-file-custom label'),
        labelVal = label.innerHTML;

    input.addEventListener('change', function (e) {
        var fileName = '';
        if (this.files && this.files.length > 1) {
            fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
        } else {
            fileName = e.target.value.split("\\").pop();
        }

        if (fileName) {
            label.text(fileName);
        } else {
            label.innerHTML = labelVal;
        }
    });
});
/******/

/* Iubenda consent */
$(document).ready(function() {
    if ($('#contact-form').length) {
        document.getElementById("form_submit_contacts").onclick = function() {
            sendToConsentSolution();
        };
        function sendToConsentSolution() {
            _iub.cons_instructions.push(["submit", {
                form: {
                    selector: document.getElementById("contact-form"),
                    map: {
                        subject: {
                            first_name: "form-nome",
                            last_name: "form-cognome",
                            email: "form-email",
                            phone: "form-telephone",
                        },
                        preferences: {
                            privacy_policy: "privacy-policy",
                        }
                    }
                },
                consent: {
                    legal_notices: [{
                        identifier: "privacy_policy"
                    }, ]
                }
            }])
        }
    };
});
/*****/

/* Home splider */
if ($('#home-splider').length) {
    var splideHome = new Splide('#home-splider', {
        type: 'fade',
        perPage: 1,
        autoplay: true,
        interval: 3000,
        speed: 800,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
        pagination: false,
        arrows: false,
    });

    splideHome.mount();

    const slideBottomElement = document.querySelector('.slide-bottom');


    if (slideBottomElement) {
        // calcola l'altezza dell'elemento
        const slideBottomHeight = slideBottomElement.offsetHeight;
        // crea una variabile css custom con l'altezza calcolata
        document.documentElement.style.setProperty('--slide-bottom-height', slideBottomHeight + 'px');
    }
}

if ($('#case-study-related-splider').length) {
    var splideHome = new Splide('#case-study-related-splider', {
        type: 'fade',
        perPage: 1,
        autoplay: true,
        interval: 3000,
        speed: 800,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
        pagination: false,
        arrows: true,
    });

    splideHome.mount();
}


if ($('#gallery-splider').length) {
    var splideStudy = new Splide('#gallery-splider', {
        type: 'fade',
        perPage: 1,
        autoplay: true,
        interval: 3000,
        speed: 800,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: true,
        pagination: false,
        arrows: true,
    });

    splideStudy.mount();
}
/*******/

/* Animazione riga */
$(document).ready(function () {
    function checkIfInView() {
        $('.line-animation-item').each(function () {
            const elementTop = $(this).offset().top;
            const elementBottom = elementTop + $(this).outerHeight();

            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                $(this).addClass('onView');
            } else {
                $(this).removeClass('onView');
            }
        });
    }

    // Run on page load and scroll
    $(window).on('scroll resize', checkIfInView);
    checkIfInView(); // Initial check
});
/*******/
$(document).ready(function () {
    const menuLinks = $('#menu-tecnologie a');
    const sections = [];

    // Popola dinamicamente l'array delle sezioni dai link del menu
    menuLinks.each(function () {
        const target = $(this).attr('href');
        if ($(target).length) {
            sections.push(target);
        }
    });

    function onScroll() {
        let scrollPos = $(document).scrollTop();

        sections.forEach(function (sectionId) {
            const section = $(sectionId);
            if (section.length) {
                const offsetTop = section.offset().top - 100; // margine di tolleranza
                const offsetBottom = offsetTop + section.outerHeight();

                if (scrollPos >= offsetTop && scrollPos < offsetBottom) {
                    menuLinks.removeClass('active');
                    $(`#menu-tecnologie a[href='${sectionId}']`).addClass('active');
                }
            }
        });
    }

    $(document).on('scroll', onScroll);
});
/* Menu tecnologie */

/*******/

/* Home: animazione immagini hover colonna destra */
$('#section-list .content-container').hover(
    function () {
        // Quando il mouse entra
        $('#section-list .content-container').removeClass('active');
        $('#section-list .img-container').removeClass('active');
        $(this).addClass('active');
        var img = $(this).attr('data-target');
        $(img).addClass('active');
    },
    function () {
        // Quando il mouse esce
    }
);
/******/

/* HOME Logo animazione */
$(document).ready(function () {
    if ($('.section-scaling').length) {

        gsap.registerPlugin(ScrollTrigger);

        let mm = gsap.matchMedia();

        mm.add("(min-width: 992px)", () => {

            ScrollTrigger.create({
                trigger: ".section-logo-zoomin",
                start: "0 top",
                end: "200% bottom",
                pin: true,
                pinSpacing: true,
            });

            gsap.registerPlugin(ScrollTrigger);

            /* Zoomin svg mask */
            let tween2 = gsap.to(".overlay-bg", {
                scale: '10',
                scrollTrigger: {
                    trigger: ".section-logo-zoomin",
                    start: "top",
                    end: '200% bottom',
                    scrub: 0.5,
                    ease: "power4.in",
                    //markers: true,
                    id: "ZoomIn-img",
                },
            });
            tween2.scrollTrigger.disable();
            gsap.delayedCall(0, () => tween2.scrollTrigger.enable());

            /* Rendo invisibile il logo */
            let tween4 = gsap.to(".overlay-bg", {
                opacity: '0',
                //z-index: '0',
                scrollTrigger: {
                    trigger: ".section-logo-zoomin",
                    start: "0 top",
                    end: '200% bottom',
                    scrub: 0.5,
                    ease: "power4.in",
                    //markers: true,
                    id: "img-claim-opacity",
                }
            });
            tween4.scrollTrigger.disable();
            gsap.delayedCall(0, () => tween4.scrollTrigger.enable());


            /* Animazione leggera immagine di sfondo */
            let tween3 = gsap.to(".main-claim", {
                scale: '1.1',
                scrollTrigger: {
                    trigger: ".main-claim",
                    start: "top",
                    end: '200% top',
                    scrub: 0.5,
                    ease: "power3.inOut",
                    //markers: true,
                    id: "img-claim",
                }
            });
            tween3.scrollTrigger.disable();
            gsap.delayedCall(0, () => tween3.scrollTrigger.enable());

            let tween5 = gsap.to(".content-claim-top", {
                x: 0,
                scrollTrigger: {
                    trigger: ".main-claim",
                    start: "center",
                    end: '300% bottom',
                    scrub: 0.5,
                    //markers: true,
                    id: "testo-top",
                    toggleClass: {
                        targets: '.content-claim-top',
                        className: "active"
                    }
                }
            });
            tween5.scrollTrigger.disable();
            gsap.delayedCall(0, () => tween5.scrollTrigger.enable());

            let tween6 = gsap.to(".content-claim-bottom", {
                x: 0,
                scrollTrigger: {
                    trigger: ".main-claim",
                    start: "center",
                    end: '300% bottom',
                    scrub: 0.5,
                    //markers: true,
                    id: "testo-bottom",
                    toggleClass: {
                        targets: '.content-claim-bottom',
                        className: "active"
                    }
                }
            });
            tween6.scrollTrigger.disable();
            gsap.delayedCall(0, () => tween6.scrollTrigger.enable());

        });

    }

    window.addEventListener('load', () => {
        ScrollTrigger.refresh();
    });
    AOS.refresh();

});
/******/

/* Cta logo */
$(document).ready(function () {

    if ($('#cta').length) {

        function isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            );
        }

        let animated = false;

        $(window).on('scroll load', function () {
            const logo = $('#ctalogo')[0];
            if (!animated && isInViewport(logo)) {
                animated = true;
                const paths = $('#ctalogo path');
                paths.each(function (i) {
                    setTimeout(() => {
                        $(this).css('opacity', 1);
                    }, i * 200); // 500ms di intervallo tra un path e l’altro
                });
            }
        });

    }
});
/****/

/* Timeline */
if ($('.row-timeline-full').length) {
    let animationStarted = false;

    $(window).on('scroll', function () {
        const $timeline = $('.row-timeline-full');
        const timelineTop = $timeline.offset().top;
        const timelineHeight = $timeline.outerHeight();
        const windowHeight = $(window).height();
        const scrollTop = $(window).scrollTop();

        const dot = $('#dot');
        const lineFill = $('#lineFill');

        const activationPoint = scrollTop + windowHeight / 2;

        const distanceFromTop = activationPoint - timelineTop;

        // Attiva l'animazione solo se il centro dello schermo ha raggiunto il top del dot
        if (!animationStarted && activationPoint >= timelineTop) {
            animationStarted = true;
        }

        if (animationStarted) {
            // calcolo percentuale scroll relativa alla sezione
            const relativeScroll = scrollTop + windowHeight / 2 - timelineTop;
            const maxScrollable = timelineHeight;

            // limiti
            const progress = Math.min(Math.max(relativeScroll, 0), maxScrollable);

            // aggiorna la linea bianca e la posizione del dot
            lineFill.css('height', progress + 'px');
            dot.css('top', progress + 'px');
        }
    });
}
/****/

/* Play video */
$(document).ready(function () {
    if ($('.play-video').length) {
        $('.play-video').on('click', function () {
            var videoSelector = $(this).data('target');
            var placeholderSelector = $(this).data('container');

            var $video = $(videoSelector);
            var $placeholder = $(placeholderSelector);

            if ($(this).hasClass('video-type-file')) {
                if ($video.length && $placeholder.length) {
                    $placeholder.fadeOut(300, function () {
                        $video.get(0).play();
                    });
                }
            } else if ($(this).hasClass('video-type-link')) {
                if ($video.length && $placeholder.length) {
                    $placeholder.fadeOut(300, function () {
                        var currentSrc = $video.attr('src');

                        // Aggiunge ?autoplay=1 o &autoplay=1 se ci sono già parametri
                        if (currentSrc.indexOf('autoplay=1') === -1) {
                            var separator = currentSrc.indexOf('?') !== -1 ? '&' : '?';
                            $video.attr('src', currentSrc + separator + 'autoplay=1');
                        }
                    });
                }
            }
        });
    }
});
/****/



/* Refresh AOS*/
AOS.refresh();

setTimeout(function () {
    AOS.refresh();
}, 2000);
/* end refresh */



document.addEventListener("DOMContentLoaded", function () {

    var gallerySlider = document.querySelector("section.carosello-case-study .carousel-wrap");

    if (gallerySlider) {
        gallerySlider = new Splide("section.carosello-case-study .carousel-wrap", {
            type: 'loop',
            perPage: 1,
            drag: true,
            pagination: false,
            autoHeight: true,
            arrows: false,
            gap: '30px',
            padding: '20vw',
            focus: 'center',
            breakpoints: {
                1150: {
                    padding: '10vw',
                },
                767: {
                    gap: '15px',
                    padding: { left: '10vw', right: '10vw' }
                },
            },
        }).mount();
    }
});



function setLoadingState(isLoading) {
    var loadingScreen = document.querySelector('.loading');
    if (isLoading) {
        loadingScreen.style.display = 'flex';
    } else {
        loadingScreen.style.display = 'none';
    }
}


// filtri ajax case study
document.addEventListener("DOMContentLoaded", function () {
    var activeFilters = {};

    var currentUrl = window.location.href;

    var baseUrl = "/";

    if (currentUrl.indexOf("/it/") !== -1) {
        baseUrl = "/it/";
    } else if (currentUrl.indexOf("/en/") !== -1) {
        baseUrl = "/en/";
    }

    if (document.querySelector(".case-container") != null) {
        // AJAX filtri case study
        $(".js-filter").on("click", function () {
            var term = $(this).data("term");
            var tax = $(this).data("tax");

            // Rimuovi tutti i filtri con lo stesso data-tax
            $(".js-filter[data-tax='" + tax + "']").removeClass("is-active");
            if (activeFilters[tax]) {
                activeFilters[tax] = [];
            }

            // Aggiungi il nuovo filtro se non è già presente
            if (!activeFilters[tax] || !activeFilters[tax].includes(term)) {
                if (!activeFilters[tax]) {
                    activeFilters[tax] = [];
                }
                activeFilters[tax].push(term);
                $(this).addClass("is-active");
            }

            console.log(activeFilters);

            $(".js-clear-filters").removeClass("is-active");

            setLoadingState(true);

            $.ajax({
                url: baseUrl + "wp-admin/admin-ajax.php",
                data: {
                    action: "filter_case_study",
                    term: activeFilters,
                },
                type: "post",
                success: function (result) {
                    $(".ajax__posts").html(result);
                    setLoadingState(false);
                },
            });
        });

        $(".js-clear-filters").on("click", function () {
            activeFilters = {};

            $(".js-filter").removeClass("is-active");

            $(this).addClass("is-active");

            setLoadingState(true);

            $.ajax({
                url: baseUrl + "wp-admin/admin-ajax.php",
                data: {
                    action: "filter_case_study",
                    term: activeFilters,
                },
                type: "post",
                success: function (result) {

                    $(".ajax__posts").html(result);

                    setLoadingState(false);
                },
            });
        });
    }

});




// allinea altezza testi laterali di grey-section
document.addEventListener('DOMContentLoaded', function () {
    let x = window.matchMedia("(min-width: 768px)");

    if (x.matches) {
        const h4Elements = document.querySelectorAll('.grey-section .content-aside');

        let maxHeight = 0;
        h4Elements.forEach(h4 => {
            const height = h4.offsetHeight;
            maxHeight = Math.max(maxHeight, height);
        });

        h4Elements.forEach(h4 => {
            h4.style.height = maxHeight + 'px';
        });
    }
});



document.addEventListener('DOMContentLoaded', function () {

    const preventivatore = document.querySelector('.p3d-canvas-wrapper');
    if (preventivatore) {
        document.getElementById('p3d-pickfiles').style.display = "none";
        const textContainer = document.createElement("button");
        textContainer.setAttribute("onclick", "document.getElementById('p3d-pickfiles').click()");
        textContainer.classList.add("text-container");
        textContainer.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="71" height="71" viewBox="0 0 71 71" fill="none">
            <circle cx="35.5" cy="35.5" r="35.5" fill="#E83A00"/>
            <path d="M21 34L36 20L51 34" stroke="white" stroke-width="4"/>
            <path d="M36 21L36 51" stroke="white" stroke-width="4"/>
            </svg>
            <h3>Carica qui il tuo file .stl/.obj</h3>
            <p>(Solo pezzi singoli)</p>
        `;
        preventivatore.appendChild(textContainer);

        textContainer.addEventListener("click", function () {
            textContainer.classList.add("hidden");
            document.getElementById('p3d-pickfiles').style.display = "block";

            document.querySelector('.p3d-product-form').style.display = "block";
        });

        // aggiunta pulsanti + e - in quantità carrello
        const quantityDiv = document.querySelector(".p3d-quantity");
        const input = quantityDiv.querySelector(".p3d-qty");

        // Crea pulsanti
        const btnMinus = document.createElement("button");
        btnMinus.textContent = "-";
        btnMinus.type = "button";
        btnMinus.classList.add("p3d-minus");

        const btnPlus = document.createElement("button");
        btnPlus.textContent = "+";
        btnPlus.type = "button";
        btnPlus.classList.add("p3d-plus");

        // Aggiungi i pulsanti
        quantityDiv.insertBefore(btnMinus, input);
        quantityDiv.appendChild(btnPlus);

        // Gestisci click
        btnMinus.addEventListener("click", function () {
            let current = parseInt(input.value) || 0;
            const min = parseInt(input.min) || 0;
            const step = parseInt(input.step) || 1;
            if (current > min) {
                input.value = current - step;
                input.dispatchEvent(new Event("change")); // opzionale
            }
        });

        btnPlus.addEventListener("click", function () {
            let current = parseInt(input.value) || 0;
            const step = parseInt(input.step) || 1;
            const max = input.max ? parseInt(input.max) : Infinity;
            if (current < max) {
                input.value = current + step;
                input.dispatchEvent(new Event("change")); // opzionale
            }
        });
    }

});